<template>
    <div class="cnt">
        <Breadcrumb :current="2" />
        <h2 class="mb-[20px] sm:mb-[40px]">Seleziona il tipo di veicolo</h2>

        <div class="flex flex-col sm:flex-row gap-[15px] sm:gap-[30px] sm:gap-0 items-center justify-around flex-wrap">
            <div v-if="mainStore?.cliente?.ricercaTargaIn?.includes('a')" class="button p-[20px]"
                :class="{ 'button-selected': mainStore?.type === 'auto' }" @click="selectVehicle('auto')">
                <font-awesome-icon icon="fa-solid fa-car-side" class="h-[50px]" />
            </div>
            <div v-if="mainStore?.cliente?.ricercaTargaIn?.includes('vc')" class="button p-[20px]"
                :class="{ 'button-selected': mainStore?.type === 'vcom' }" @click="selectVehicle('vcom')">
                <font-awesome-icon icon="fa-solid fa-truck-moving" class="h-[50px]" />
            </div>
        </div>

        <div v-if="mainStore?.type"
            class="flex flex-col sm:flex-row gap-[15px] sm:gap-[30px] sm:gap-0 items-center justify-around flex-wrap mt-[30px]">
            <div v-if="mainStore?.type == 'auto' ? mainStore?.cliente?.mercatoNuovoAuto : mainStore?.cliente?.mercatoNuovoVcom"
                class="button p-[20px]" @click="selectMercato('nuovo')">
                MERCATO NUOVO
            </div>
            <div class="button p-[20px]" @click="selectMercato('usato')">
                MERCATO USATO
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from './Breadcrumb.vue';
import { mainStore } from '../../../store/main';

export default {
    name: 'SceltaVeicolo',
    components: { Breadcrumb },

    data() {
        return {
            mainStore,
        }
    },

    methods: {
        selectVehicle(type) {
            this.mainStore.type = type;
            //this.$router.push("/ricerca-modello");
        },
        selectMercato(mercato) {
            this.mainStore.mercato = mercato;
            this.$router.push("/forecast/ricerca-modello");
        },
    }
}
</script>

<style scoped>
.cnt {
    text-align: left;
    display: grid;
    width: 100%;
}
</style>